import React from "react";
import "./challenge-theme-item.css";
import {
  capitalizeAll,
  colors,
  randomElement,
} from "../../../../core/utils/helpers";
import { BiSolidColor } from "react-icons/bi";
import { IoIosColorPalette, IoIosColorFilter } from "react-icons/io";
import { IoColorFilter, IoColorFilterSharp } from "react-icons/io5";
import { MdColorLens, MdOutlineColorLens, MdQuiz } from "react-icons/md";
import { GoClock } from "react-icons/go";
import moment from "moment";

const iconsArray = [
  BiSolidColor,
  IoIosColorPalette,
  IoIosColorFilter,
  IoColorFilter,
  IoColorFilterSharp,
  MdColorLens,
  MdOutlineColorLens,
];

const ChallengeThemeItem = ({ data, onAction }) => {
  const Icon = randomElement(iconsArray); // Must be capitalized
  const color = randomElement(colors); // Must be capitalized

  const _title = data?.title_en;
  const _theme_category = data?.challenge_theme_category_title_en;
  const _total_questions = data?.total_questions;
  const _created_at = data?.updated_at;


  return (
    <div
      className="challenge-theme-item"
      onClick={() => onAction(data)}
    >
      <span className="stick" style={{ backgroundColor: color }}>
        <Icon className="icon" />
      </span>
      <div className="challenge-theme-item-details">
        <h3>{capitalizeAll(_title)}</h3>
        <h4>{capitalizeAll(_theme_category)}</h4>
        <div className="row">
          <MdQuiz className="icon" />
          <span>
            {_total_questions} {_total_questions > 1 ? "Questions" : "Question"}
          </span>
        </div>
        <div className="row">
          <GoClock className="icon" />
          <span>Edited : {moment(_created_at).fromNow()}</span>
        </div>
      </div>
    </div>
  );
};

export default ChallengeThemeItem;
